import { render } from "./SurveyToolTallying.vue?vue&type=template&id=8c2d19f6"
import script from "./SurveyToolTallying.vue?vue&type=script&lang=js"
export * from "./SurveyToolTallying.vue?vue&type=script&lang=js"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__